<template>
	<div class="logon">
		
	</div>
</template>

<script>
	export default {
		name: 'forget',
		components: {
		 
		},
		props: {
	
		},
		data () {
			return {
				id: "",
				type: "",
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.type = this.$route.query.type;
		},
		mounted() {
			this.getAlipay();
		},
		methods: {
			getAlipay () {
				this.$get("/api/chargeopt/add_charge_order",{
					token: localStorage.getItem("token"),
					id: this.id,
					type: this.type,
					return_url: "http://test1.joy366.com/payment",
					platform: 1,
				})
				.then(res => {
					
				});
			},
		},
	}
</script>

<style>
</style>
